import { render } from "./IcelandView.vue?vue&type=template&id=527b218e"
import script from "./IcelandView.vue?vue&type=script&lang=js"
export * from "./IcelandView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__